module.exports = __webpack_public_path__ + "static/media/14.7bd63e3a.png";